import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantUnemploymentDetailsPage = {
  alert: {
    error: 'coapplicant-unemployment-details-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-unemployment-details-page.footer.root',
  },
  form: {
    grossAnnualIncomeInput:
      'coapplicant-unemployment-details-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'coapplicant-unemployment-details-page.form.gross-annual-income-input-error',
    h1: 'coapplicant-unemployment-details-page.form.h1',
    h2: 'coapplicant-unemployment-details-page.form.h2',
    root: 'coapplicant-unemployment-details-page.form.root',
    submitButton: 'coapplicant-unemployment-details-page.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-unemployment-details-page.header.drawer-button',
    previousStepButton:
      'coapplicant-unemployment-details-page.header.previous-step-button',
    root: 'coapplicant-unemployment-details-page.header.root',
  },
  progress: {
    root: 'coapplicant-unemployment-details-page.progress.root',
  },
} as const satisfies PageLocatorMap;
